var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="custom_empty"> <div class="content-wrapper" data-help="custom"> <div class="row"> <div class="col-sm-9"> <div class="row"> <div class="col-sm-12 pr-0"> <h3 class="text-dark font-weight-bold mb-0 mr-5">'+
((__t=( resources['X200429'] ))==null?'':__t)+
'</h3> </div> </div> </div> </div> <div class="row mt-3"> <div class="col-12 grid-margin stretch-card"> <div class="card"> <div class="card-body"> <div id="customInformation" class="e4usInformation" style="display:none"></div> <h4 class="card-title">'+
((__t=( resources['X200429'] ))==null?'':__t)+
'</h4> <form class="forms-sample"> <div class="col-3 col-sm-6 col-md-3 col-xl-3"> <div id="pomodoro_group_PomodoroTime" class="form-group"> <label>'+
((__t=( resources['X200287'] ))==null?'':__t)+
'</label> <input class="form-control" id="pomodoro_inputPomodoroTime" value="'+
((__t=( model.PomodoroTime))==null?'':__t)+
'"> </div> </div> <div class="col-3 col-sm-6 col-md-3 col-xl-3"> <div id="pomodoro_group_ShortBreak" class="form-group"> <label>'+
((__t=( resources['X200288'] ))==null?'':__t)+
'</label> <input class="form-control" id="pomodoro_inputShortBreak" value="'+
((__t=( model.ShortBreak))==null?'':__t)+
'"> </div> </div> <div class="col-3 col-sm-6 col-md-3 col-xl-3"> <div id="pomodoro_group_LongBreak" class="form-group"> <label>'+
((__t=( resources['X200289'] ))==null?'':__t)+
'</label> <input class="form-control" id="pomodoro_inputLongBreak" value="'+
((__t=( model.LongBreak))==null?'':__t)+
'"> </div> </div> <div class="form-group"> <label for="pomodoro_input_LongBreakCycle">'+
((__t=( resources['X200290'] ))==null?'':__t)+
'</label> <div id="pomodoro_input_LongBreakCycle" class="ul-slider slider-success" style="height: 20px"></div> <p class="mt-3">'+
((__t=( resources['X200292'] ))==null?'':__t)+
' <span id="pomodoro_input_LongBreakCycleValue">'+
((__t=( model.LongBreakCycle))==null?'':__t)+
'</span></p> </div> <button type="button" class="btn btn-primary btn-sm" id="custom_btnSubmit">'+
((__t=( resources['X200059'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-sm" id="custom_btnDefault">'+
((__t=( resources['X200430'] ))==null?'':__t)+
'</button> </form> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
